export default "__VITE_ASSET__sqn87EHK__"